export default __webpack_public_path__ + "assets/webgl/complete-24.b5bbf7e4.jpg";